import { observable, IObservableArray, computed } from "mobx";
import { FilesUIStore } from "../Stores/FilesUIStore";
import { IDocumentsView } from "../Document/DocumentsView";
import { Strings } from "../Stores/StringsStore";
import * as DocumentReader from "../DocumentReader";
import { DialogStore } from "../Stores/DialogStore";

export class SyncUIStore extends FilesUIStore implements IDocumentsView {

	/*No Result message*/
	noResultMsg: string = Strings.sync.syncPlaceholderTextforEmptyResult;

	selectedFiles: IObservableArray<DocumentReader.FileResultInfo> = observable.array([]);

	@computed get scrollLock(): boolean {
		return (this.searchResult.documents.length >= this.skip + this.top)
	}

	/**
	 * Triggers the search
	 */
	public triggerSearch(resetPagination?: boolean, isScrolling: boolean = false) {
		if (!this.isBusy) {
			this.isBusy = true;
			DocumentReader.queryUpdatedDocumentsAsync().then(result => {
				if (this.skip == 0) {
					this.searchResult.documents.replace(result.documents);
				}
				else {
					this.searchResult.documents.push(...result.documents);
				}
				this.isBusy = false;
			}).catch(error => {
				DialogStore.showError(Strings.general.errorDialogTitle, error);
				this.isBusy = false;
			});
		}
	}
}